import { combineReducers } from 'redux'

import { makeCommunicationReducer } from 'shared/utils/communication/reducer/makeCommunicationReducer'

import * as actions from '../actions'
import { IUpgamingState } from '../types'

export default combineReducers<IUpgamingState['communications']>({
  createSession: makeCommunicationReducer(actions.createSession),
  createGuestSession: makeCommunicationReducer(actions.createGuestSession),
})
